<template>
  <div>
    <v-card v-if="table">
      <v-card-title :style="getThemeStyle">
        {{ title }}
        <v-spacer></v-spacer>
        <v-text-field
          dark
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="itemsPerPage"
      >
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },
  props: {
    table: {
      default: null,
    },
    title: {
      default: "Data Title",
    },
    items: {
      default: [],
    },
    headers: {
      default: [],
    },
    height: {
      default: "400px",
    },
    itemsPerPage: {
      default: 50,
    },
  },
  data: () => ({
    search: "",
    switchValue: false,
  }),
};
</script>

<style></style>
